// https://stackoverflow.com/a/21553982/624476

export default href => {
  let match = href.match(/^(https?:)\/\/(([^:/?#]*)(?::([0-9]+))?)([/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/)
  return (match && `${match[5]}${match[6]}`) || href
}
